import React from "react";
import Card from "react-bootstrap/Card";

function Area_Accion() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          
          <p style={{ textAlign: "justify" }}>
           En Singularity organizamos nuestro trabajo en cinco áreas clave que guían nuestras actividades y proyectos. Cada área concentra esfuerzos específicos para maximizar el impacto social, promover la innovación tecnológica, asegurar la sustentabilidad económica, difundir el conocimiento abierto y fortalecer la organización interna del club.

          </p>

        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default Area_Accion;
